export default function createSchemaFaqForVaspPages(vaspName?: string | null | undefined) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: `Is ${vaspName} regulated?`,
        acceptedAnswer: {
          "@type": "Answer",
          text: `Find out if ${vaspName} is regulated by signing up to Notabene’s free VASP network!`,
        },
      },
      {
        "@type": "Question",
        name: `Is ${vaspName} safe to do Travel Rule transfers?`,
        acceptedAnswer: {
          "@type": "Answer",
          text: `Find out if ${vaspName} Crypto Travel Rule complaint by signing up to Notabene’s free VASP network!`,
        },
      },
    ],
  };
}
